import React, { useState } from 'react';

import { chaveDaMarcada, IEmpresaMarcada, janelaDoCarrossel } from '../../regrasDaCarteira';
import { Anterior, Proximo } from '../icones';
import { AbaDoDetalhe, DetalheDaEmpresa } from './DetalheDaEmpresa';
import { LINK } from './estilos';

/**
 * Empresas marcadas nos cards: uma mostra o detalhe; várias viram um carrossel,
 * com uma etiqueta por empresa, setas e a posição. Fica no lugar de "O que falta
 * para liberar" enquanto houver empresa marcada.
 */
export function DetalheDaSelecao({
  marcadas,
  atual,
  onIr,
  onLimpar,
  onAbrirTela,
}: {
  marcadas: IEmpresaMarcada[];
  atual: number;
  onIr: (i: number) => void;
  onLimpar: () => void;
  onAbrirTela: (e: IEmpresaMarcada, aba: AbaDoDetalhe) => void;
}) {
  const [aba, setAba] = useState<AbaDoDetalhe>('resumo');
  const [expandido, setExpandido] = useState(false);
  const n = marcadas.length;
  const idx = Math.min(atual, n - 1);
  const e = marcadas[idx];
  const [ini, fim] = janelaDoCarrossel(n, idx, expandido);
  // trocar de empresa volta para o resumo, como no layout
  const ir = (i: number) => {
    setAba('resumo');
    onIr(i);
  };

  return (
    <section
      aria-label="Detalhe da empresa"
      style={{
        background: '#FFFFFF',
        border: '1px solid #E4E4E7',
        borderRadius: 16,
        padding: '18px 20px 22px',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <div className="carroTopo">
        <div
          style={{
            flex: '1 1 auto',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 8,
            minWidth: 0,
          }}
        >
          <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: '.06em',
              textTransform: 'uppercase',
              color: '#64748B',
              whiteSpace: 'nowrap',
            }}
          >
            {n > 1 ? `${n} empresas selecionadas` : 'Empresa selecionada'}
          </span>
          {marcadas.slice(ini, fim).map((m, k) => {
            const i = ini + k;
            const ativo = i === idx;
            return (
              <button
                type="button"
                key={chaveDaMarcada(m)}
                className="chip"
                onClick={() => ir(i)}
                aria-pressed={ativo}
                title={m.razao}
                style={{
                  maxWidth: 230,
                  padding: '4px 11px',
                  borderRadius: 999,
                  fontSize: 11.5,
                  fontWeight: 600,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  border: `1.5px solid ${ativo ? '#1B6FD0' : '#E4E4E7'}`,
                  background: ativo ? '#E9F4FD' : 'rgba(255, 255, 255, .8)',
                  color: ativo ? '#155FB0' : '#3F3F46',
                }}
              >
                {m.razao}
              </button>
            );
          })}
          {n > 4 && (
            <button
              type="button"
              onClick={() => setExpandido(v => !v)}
              style={{
                padding: '4px 11px',
                borderRadius: 999,
                fontSize: 11.5,
                fontWeight: 700,
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                border: '1.5px dashed #93C5FD',
                background: 'rgba(233, 244, 253, .8)',
                color: '#155FB0',
              }}
            >
              {expandido ? 'mostrar menos' : `+${n - 3} empresas`}
            </button>
          )}
        </div>
        <div className="carroCtl">
          {n > 1 && (
            <>
              <button
                type="button"
                className="carroBtn"
                aria-label="Empresa anterior"
                onClick={() => ir((idx - 1 + n) % n)}
              >
                <Anterior tam={14} cor="#0F172A" traco={2.4} />
              </button>
              <span
                style={{
                  minWidth: 52,
                  textAlign: 'center',
                  fontSize: 12.5,
                  fontWeight: 700,
                  color: '#0F172A',
                }}
              >
                {idx + 1} de {n}
              </span>
              <button
                type="button"
                className="carroBtn"
                aria-label="Próxima empresa"
                onClick={() => ir((idx + 1) % n)}
              >
                <Proximo tam={14} cor="#0F172A" traco={2.4} />
              </button>
            </>
          )}
          <button
            type="button"
            onClick={() => onAbrirTela(e, aba)}
            style={{
              height: 32,
              padding: '0 12px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              borderRadius: 8,
              border: '1px solid #CBD5E1',
              background: 'rgba(255, 255, 255, .85)',
              color: '#0F172A',
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Abrir tela completa
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#0F172A"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M7 17L17 7M9 7h8v8" />
            </svg>
          </button>
          <button type="button" onClick={onLimpar} style={{ ...LINK, padding: '0 4px' }}>
            {n > 1 ? 'limpar seleção' : 'fechar detalhe'}
          </button>
        </div>
      </div>

      <DetalheDaEmpresa
        key={chaveDaMarcada(e)}
        empresaId={e.id}
        competencia={e.competencia}
        razao={e.razao}
        aba={aba}
        onAba={setAba}
      />
    </section>
  );
}
